module.exports = __webpack_public_path__ + "static/media/highlight_title.a2b84cba.png";